export function decodeURIComponentSafe(value: string): string {
  if (typeof value !== 'string') return value as any;

  let result = value;
  let last = null;

  while (result !== last) {
    last = result;
    try {
      result = decodeURIComponent(result);
    } catch {
      break;
    }
  }

  return result;
}

export function safeEncodeURIComponent(value: string): string {
  if (typeof value !== 'string') return value as any;

  let decoded = decodeURIComponentSafe(value);
  decoded = decoded.replace(/\uFFFD+/g, '');
  decoded = decoded.normalize('NFC');
  return encodeURIComponent(decoded);
}
